import { Routes } from '@angular/router';
import { RouteNames } from './core/models/Common';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { HomeComponent } from './components/home/home.component';
import { authGuard } from './core/guards/auth.gaurd';
import { loginRedirectGuard } from './core/guards/login.gaurd';

export const routes: Routes = [
  {
    path: RouteNames.Login,
    component: SignInComponent,
    canActivate: [loginRedirectGuard],
  },
  {
    path: RouteNames.Landing,
    redirectTo: RouteNames.Login,
  },
  {
    path: RouteNames.Home,
    component: HomeComponent,
    canActivate: [authGuard],
  },
];
